import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FiGift } from 'react-icons/fi';
import { Colors } from '../utils/colors';
import { Sizes } from '../utils/sizes';

const Wrap = styled.section`
  width: 100%;
  background: linear-gradient(135deg, #1a1200 0%, #0f0f0f 100%);
  padding: 70px 24px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,215,0,0.2), transparent);
  }
`;

const Inner = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 60px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    gap: 40px;
  }

  @media (max-width: ${Sizes.mediaQueryBreak2}) {
    flex-direction: column;
    text-align: center;
    gap: 28px;
    align-items: center;
  }
`;

const ImgWrap = styled.div`
  flex-shrink: 0;

  img {
    width: 200px;
    border-radius: 10px;
    box-shadow: 0 16px 50px rgba(0,0,0,0.5);
    border: 1px solid rgba(255,215,0,0.2);

    @media (max-width: ${Sizes.mediaQueryBreak2}) {
      width: 160px;
    }

    @media (max-width: ${Sizes.mediaQueryBreak3}) {
      width: 140px;
    }
  }
`;

const TextWrap = styled.div`
  flex: 1;
`;

const FreeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,215,0,0.12);
  border: 1px solid rgba(255,215,0,0.35);
  color: ${Colors.yellow};
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 4px 12px;
  border-radius: 20px;
  margin-bottom: 14px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 800;
  margin: 0 0 10px;

  span { color: ${Colors.yellow}; }
`;

const Sub = styled.p`
  color: rgba(255,255,255,0.6);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0 0 28px;
`;

const Btn = styled.button`
  background: ${Colors.yellow};
  color: #0a0a0a;
  border: none;
  padding: 14px 36px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255,215,0,0.3);
  }
`;

const Section = () => {
  const navigate = useNavigate();

  return (
    <Wrap>
      <Inner>
        <ImgWrap>
          <img src="/capaEbooksLoja/image.png" alt="e-Book grátis Viola Católico" />
        </ImgWrap>
        <TextWrap>
          <FreeBadge><FiGift size={13} /> Totalmente gratuito</FreeBadge>
          <Title>
            Conheça meu trabalho com um<br />
            <span>e-book extra sem custo</span>
          </Title>
          <Sub>
            Baixe agora, sem precisar pagar nada. Uma amostra da qualidade
            das cifras e da organização que você encontra em toda a coleção.
          </Sub>
          <Btn onClick={() => navigate('/produto/cifras-musicas-extras')}>
            BAIXAR GRÁTIS AGORA
          </Btn>
        </TextWrap>
      </Inner>
    </Wrap>
  );
};

export default Section;
